import React from "react";
import { DateTime } from "luxon";
import Control from "../../../../common/Control";
import ChangeEpAddress from "../../ChangeEpAddress";

const EPFormFields = ({
  myEp,
  setMyEp,
  errors,
  isDisabled,
  sectors,
  allSectors,
}) => {
  const hours = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
  const minutes = [0, 15, 30, 45];

  return (
    <>
      <div className="col-12 col-md-3">
        <Control
          disabled={isDisabled}
          label="Date"
          type="date"
          name="beginAt"
          value={DateTime.fromISO(myEp.beginAt).toFormat("yyyy-MM-dd")}
          change={(e) =>
            setMyEp({
              ...myEp,
              beginAt: e.target.value,
            })
          }
          error={errors}
        />
      </div>
      <div className="col-6 col-md-3">
        <Control
          disabled={isDisabled}
          label="Heure de début"
          type="select"
          name="beginHourAt"
          datas={hours.map((h) => ({ id: h, name: h + " H" }))}
          value={myEp.beginHourAt}
          change={(e) => setMyEp({ ...myEp, beginHourAt: e.target.value })}
          error={errors}
        />
      </div>
      <div className="col-6 col-md-3">
        <Control
          disabled={isDisabled}
          label="Minute de début"
          type="select"
          name="beginMinuteAt"
          datas={minutes.map((m) => ({ id: m, name: m }))}
          value={myEp.beginMinuteAt}
          change={(e) => setMyEp({ ...myEp, beginMinuteAt: e.target.value })}
          error={errors}
        />
      </div>
      <div className="col-12 col-md-3">
        <Control
          disabled={isDisabled}
          label="Secteur"
          type="select"
          name="sector"
          value={myEp.sector}
          datas={sectors}
          change={(e) => setMyEp({ ...myEp, sector: e.target.value })}
          error={errors}
        />
      </div>
      <div className="col-12 px-4">
        <ChangeEpAddress
          myEp={myEp}
          setMyEp={setMyEp}
          errors={errors}
          sectors={allSectors}
          isDisabled={isDisabled}
        />
      </div>
      <div className="col-12 px-4">
        <Control
          disabled={isDisabled}
          label={
            <>
              Est une session de secours
              <i className="fa fa-history ml-1" />
              {" ?"}
            </>
          }
          type="checkbox"
          name="isBackupSession"
          checked={myEp.isBackupSession}
          change={(e) =>
            setMyEp({ ...myEp, isBackupSession: e.target.checked })
          }
          error={errors}
        />
      </div>
    </>
  );
};

export default EPFormFields;
